import React from "react"
import Base from "./Base"
import { Card, Row, Col, Select, Form, Input, Icon, Tooltip, DatePicker, Steps, Button, message, InputNumber, Typography, Spin } from "antd"
import { withBreakpoints } from "react-breakpoints"
import locale from 'antd/es/date-picker/locale/es_ES';
import moment from 'moment';
import { API, Auth } from "aws-amplify"
import { withRouter } from 'react-router-dom'
import InvoiceView from "../../Components/Invoices/InvoiceView"
import '../../Styles/UserPanel/Invoice.css'
import definitions from "../../Util/AFIPdefinitions"
import { connect } from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

const { Option } = Select;
const { TextArea } = Input;
const { Step } = Steps;
const { Text } = Typography;
var interval = null
var count=0

class InvoiceForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            invoiceID: null,
            maxInvoiceAmount:10000,
            checkCuit:false,
            loading: true,
            currentStep: 0,
            items: [{
                key: 0,
                codigo: 1,
                concepto: "",
                unidad: 7,
                cantidad: null,
                precio: null
            }],
            currentKey: 0,
            data: {
                tipoComprobante: 11,
                tipoResponsable: "iva-responsable-inscripto",
                razonSocial: null,
                formaPago: "cuenta-corriente",
                numeroComprobante: null,
                tipoDocumento: 80,
                numeroDocumento: null,
                domicilioComercial: null,
                localidad:null,
                provincia:null,
                moneda: "PES",
                fecha: moment(),
                email: null,
                concepto: "2",
                fechaDesde: moment(),
                fechaHasta: moment(),
                fechaVencimiento: moment(),
                tipoComprobanteAsoc: null,
                puntoVentaAsoc: null,
                cbteNroAsoc: null,
                observaciones: null
            }
        };
        this.getInvoiceStatus =  this.getInvoiceStatus.bind(this)
    }

    componentDidMount() {
        if (this.props.login.user_data.estado_usuario==='INACTIVO'|| this.props.login.user_data.estado_usuario === 'INCOMPLETO'){
            this.props.history.push('/')
        }else{
        Auth.currentSession()
        .then(response => {
            API.get(
                'test',
                '/taxes/otros',
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
            .then(response => {
                let maximo_facturacion=response.filter(otros=>otros.nombre ==='maximo_cons_final')[0]
                this.setState({maxInvoiceAmount: maximo_facturacion.valor, loading:false})

            })
            .catch(err => {
                message.error('Error leyendo Base de datos')})
                this.setState({loading:false})
        })
    }
    }

    addItem(newItem) {
        const items = this.state.items.concat(newItem);
        const currentKey = this.state.currentKey + 1;
        this.setState({ items, currentKey });
    }

    deleteItem(key) {
        const items = this.state.items.filter((value) => { return value.key !== key });
        this.setState({ items })
    }

    modifyItem(key, field, value) {
        const items = this.state.items.map((item) => {
            if (item.key === key) {
                item[field] = value
            }
            return item
        })
        this.setState({ items })
    }

    disableDate(current) {
        return current && current<moment().subtract(3,"days")
    }

    updateData(fields, values) {
        const new_data = {...this.state.data}
        for (var i =0;i<fields.length;i++) {
            new_data[fields[i]]=values[i]
        }
        this.setState({ data:new_data })
    }

    getTotal() {
        let total = this.state.items.reduce((total, item) => { return total + item.cantidad * item.precio }, 0)
        return total
    }

    next() {
        let fields = []
        switch (this.state.currentStep) {
            case 0:
                fields = [
                    'comprobante',
                    'fecha-comprobante',
                    'responsable',
                    'documento-cliente',
                    'numero-documento-cliente',
                    'razon-social-cliente',
                    'domicilio-comercial-cliente',
                    'email-cliente',
                    'fecha-desde',
                    'fecha-hasta',
                    'fecha-vencimiento',
                    'comprobante-asociado',
                    'punto-venta-asociado',
                    'comprobante-nro-asociado'
                ]
                break;
            case 1:
                fields = [
                    'item-codigo-0',
                    'item-concepto-0',
                    'item-unidad-0',
                    'item-cantidad-0',
                    'item-precio-0'
                ]
                break;
            default:
                break;
        }
        this.props.form.validateFieldsAndScroll(fields, { first: true }, (err, values) => {
            if (!err) {
                if (this.state.currentStep === 1) {
                    this.setState({ loading: true })
                    Auth.currentSession()
                        .then(session => {
                            if (this.state.invoiceID === null) {
                                API.post(
                                    'test',
                                    '/root/invoices',
                                    {
                                        headers: {
                                            Authorization: session.getIdToken().getJwtToken()
                                        },
                                        body: {

                                                tipoDeComprobante: parseInt(this.state.data.tipoComprobante),
                                                fecha: this.state.data.fecha.valueOf(),
                                                tipoResponsable: this.state.data.tipoResponsable,
                                                tipoDocumento: this.state.data.tipoResponsable === 'consumidor-final' ? 99 : parseInt(this.state.data.tipoDocumento),
                                                nroDocumento: this.state.data.tipoResponsable === 'consumidor-final' ? 0 : this.state.data.numeroDocumento,
                                                razonSocialCliente: this.state.data.razonSocial,
                                                domicilioComercialCliente: this.state.data.domicilioComercial,
                                                localidadCliente:this.state.data.localidad,
                                                provinciaCliente:this.state.data.provincia,
                                                emailCliente: this.state.data.email,
                                                formaDePago: this.state.data.formaPago,
                                                moneda: this.state.data.moneda,
                                                concepto: parseInt(this.state.data.concepto),
                                                desde: this.state.data.concepto !== "1" ? this.state.data.fechaDesde.valueOf() : null,
                                                hasta: this.state.data.concepto !== "1" ? this.state.data.fechaHasta.valueOf() : null,
                                                vencimientoPago: this.state.data.concepto !== "1" ? this.state.data.fechaVencimiento.valueOf() : null,
                                                items: this.state.items,
                                                observacion: this.state.data.observaciones,
                                                tipoDeComprobanteAsoc: (this.state.data.tipoComprobanteAsoc) ? parseInt(this.state.data.tipoComprobanteAsoc) : null,
                                                puntoVentaAsoc: this.state.data.puntoVentaAsoc,
                                                cbteNroAsoc: this.state.data.cbteNroAsoc,
                                                importeTotal:this.getTotal()
                                        }
                                    }
                                )
                                    .then(response => {
                                        message.success("Factura guardada como borrador")
                                        const currentStep = this.state.currentStep + 1
                                        this.setState({ currentStep, invoiceID: response["invoiceId"], loading: false })
                                    })
                                    .catch(err => {
                                            message.error("Error de carga de factura")
                                            this.setState({ loading: false })
                                    })
                            }
                            else {
                                API.put(
                                    'test',
                                    '/root/invoices',
                                    {
                                        headers: {
                                            Authorization: session.getIdToken().getJwtToken()
                                        },
                                        body: {
                                            invoice: {
                                                invoice_id: this.state.invoiceID,
                                                tipoDeComprobante: parseInt(this.state.data.tipoComprobante),
                                                fecha: this.state.data.fecha.valueOf(),
                                                tipoResponsable: this.state.data.tipoResponsable,
                                                tipoDocumento: this.state.data.tipoResponsable === 'consumidor-final' ? 99 : parseInt(this.state.data.tipoDocumento),
                                                nroDocumento: this.state.data.tipoResponsable === 'consumidor-final' ? 0 : this.state.data.numeroDocumento,
                                                razonSocialCliente: this.state.data.razonSocial,
                                                domicilioComercialCliente: this.state.data.domicilioComercial,
                                                localidadCliente:this.state.data.localidad,
                                                provinciaCliente:this.state.data.provincia,
                                                emailCliente: this.state.data.email,
                                                formaDePago: this.state.data.formaPago,
                                                moneda: this.state.data.moneda,
                                                concepto: parseInt(this.state.data.concepto),
                                                desde: this.state.data.concepto !== "1" ? this.state.data.fechaDesde.valueOf() : null,
                                                hasta: this.state.data.concepto !== "1" ? this.state.data.fechaHasta.valueOf() : null,
                                                vencimientoPago: this.state.data.concepto !== "1" ? this.state.data.fechaVencimiento.valueOf() : null,
                                                items: this.state.items,
                                                tipoDeComprobanteAsoc: (this.state.data.tipoComprobanteAsoc) ? parseInt(this.state.data.tipoComprobanteAsoc) : null,
                                                puntoVentaAsoc: this.state.data.puntoVentaAsoc,
                                                cbteNroAsoc: this.state.data.cbteNroAsoc,
                                                observacion: this.state.data.observaciones,
                                                estado:'PENDING_AFIP',
                                                importeTotal:this.getTotal()
                                            }
                                        }
                                    }
                                )
                                    .then(response => {
                                        message.success("Borrador actualizado")
                                        const currentStep = this.state.currentStep + 1
                                        this.setState({ currentStep, invoiceID: response["invoice_id"], loading: false })
                                    })
                                    .catch(err => {

                                        message.error("Error de actualización de factura")
                                        this.setState({ loading: false })
                                    })
                            }
                        })
                        .catch(err => {
                            message.error("Error obteniendo credenciales de usuario")
                        })
                }
                else {
                    const currentStep = this.state.currentStep + 1
                    this.setState({ currentStep })
                }

            }
        })

    }

    prev() {
        const currentStep = this.state.currentStep - 1;
        this.setState({ currentStep });
    }

    submitFactura() {
        this.setState({ loading: true })
        Auth.currentSession()
        .then(session => {
            API.put(
                'test',
                '/root/invoices/'+this.state.invoiceID,
                {
                    headers: {
                        Authorization: session.getIdToken().getJwtToken()
                    },
                    body: {
                            tipoDeComprobante: parseInt(this.state.data.tipoComprobante),
                            nroDeComprobante: this.state.data.numeroComprobante,
                            fecha: this.state.data.fecha.valueOf(),
                            tipoResponsable: this.state.data.tipoResponsable,
                            tipoDocumento: parseInt(this.state.data.tipoDocumento),
                            nroDocumento: this.state.data.tipoDocumento === 99 ? null : this.state.data.numeroDocumento,
                            razonSocialCliente: this.state.data.razonSocial,
                            domicilioComercialCliente: this.state.data.domicilioComercial,
                            localidadCliente:this.state.data.localidad,
                            provinciaCliente:this.state.data.provincia,
                            emailCliente: this.state.data.email,
                            formaDePago: this.state.data.formaPago,
                            moneda: this.state.data.moneda,
                            concepto: parseInt(this.state.data.concepto),
                            desde: this.state.data.concepto !== "1" ? this.state.data.fechaDesde.valueOf() : null,
                            hasta: this.state.data.concepto !== "1" ? this.state.data.fechaHasta.valueOf() : null,
                            vencimientoPago: this.state.data.concepto !== "1" ? this.state.data.fechaVencimiento.valueOf() : null,
                            items: this.state.items,
                            tipoDeComprobanteAsoc: (this.state.data.tipoComprobanteAsoc) ? parseInt(this.state.data.tipoComprobanteAsoc) : null,
                            puntoVentaAsoc: this.state.data.puntoVentaAsoc,
                            cbteNroAsoc: this.state.data.cbteNroAsoc,
                            observacion: this.state.data.observaciones,
                            importeTotal:this.getTotal(),
                            action:'PROCESS'
                    }
                }
            )
            .then(response => {

                interval = setInterval(this.getInvoiceStatus, 2500, this.state.invoiceID)

            })
            .catch(err => {
                message.error("Hubo un error enviando la factura")
                this.setState({ loading: false })
            })
        })
    }


    componentWillUnmount() {
        if (interval !== null) {
            clearInterval(interval)
        }
    }

    getInvoiceStatus(invoiceID){
        // console.log('getInvoiceStatus',invoiceID)

        Auth.currentSession()
        .then(response => {
            API.get(
                'test',
                '/root/invoices/'+ invoiceID,
                {
                    headers: {
                        Authorization: response.getIdToken().getJwtToken()
                    }
                }
            )
                .then(response => {
                    if (count >4){
                        message.warn('Factura en cola, revisa su estado más tarde')
                        this.props.history.push('/facturas-emitidas')
                    } else{
                        count=count+1
                    switch(response.estado){
                        case 'EMITTED':
                            this.setState({ loading: false })
                            message.success('Factura emitida correctamente')
                            this.props.history.push('/facturas-emitidas')
                            break

                        case 'PENDING_AFIP':
                            this.setState({ loading: false })
                            message.warning('La afip se encuentra fuera de servicio, procesaremos tu factura mas tarde.',4)
                            this.props.history.push('/facturas-emitidas')
                            break

                        case 'REJECTED':

                            this.setState({ loading: false })
                            message.error('Factura rechazada por AFIP')
                            this.props.history.push('/facturas-emitidas')
                            break

                        case 'CANCELED':
                            this.setState({ loading: false })
                            message.error('Factura cancelada')
                            this.props.history.push('/facturas-emitidas')
                            break

                        case 'QUEUED':
                            break

                        default:
                            break
                    }}
                    })
                })
                .catch(err => console.log(err))
        }

    cuitData() {
        message.config({maxCount:1})
        message
        .loading('Verificando CUIT...',10)
        this.setState({checkCuit:false})
        Auth.currentSession()
        .then(session => {
            API.get(
                'test',
                '/contribuyente',
                {
                    headers: {
                        Authorization: session.getIdToken().getJwtToken()
                    },
                    queryStringParameters: {
                        cuit:this.state.data.numeroDocumento
                    }
                }
            )
            .then(response => {

                if (this.state.data.tipoResponsable==='iva-responsable-inscripto' && response['IVA']===('N'||'n'||'NO'||'no')){
                    message.warning('El CUIT no corresponde a un Responsable Inscripto')
                    this.updateData(["numeroDocumento","domicilioComercial","razonSocial"],[null, null, null])
                    this.props.form.resetFields(['numero-documento-cliente', 'domicilio-comercial-cliente', 'razon-social-cliente'])

                } else{
                message.success('Cuit valido!')
                let razon_social =response["razonSocial"]
                let direccion = response["Direccion"]
                let ciudad = response['Localidad']
                let provincia = response['Provincia']
                this.updateData(["domicilioComercial","razonSocial",'provincia','ciudad'],[direccion,razon_social,provincia,ciudad])
                this.props.form.setFieldsValue({
                    'razon-social-cliente':razon_social,
                    'domicilio-comercial-cliente':direccion +'-'+ciudad+'-'+provincia})
                }


            })
            .catch(err => {
                this.setState({ loading: false })
                message.error("Cuit inexistente")
                this.updateData(["numeroDocumento","domicilioComercial","razonSocial"],[null, null, null])
                this.props.form.resetFields(['numero-documento-cliente', 'domicilio-comercial-cliente', 'razon-social-cliente'])

            })
        })
        .catch(err=>{
            message.error('Error de comunicacion con AFIP')
        })
    }

    render() {
        if (this.state.loading){
            return (
                <Base selected="facturar">
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight:'360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
            </Base>)
        }else{

        let documentos_cf = definitions.documento.filter(doc => doc.value !== 80)
        const { breakpoints, currentBreakpoint } = this.props;
        const { currentStep } = this.state;
        const { getFieldDecorator, getFieldValue, resetFields } = this.props.form;
        const defaultitem = [{
            key: this.state.currentKey + 1,
            codigo: 1,
            concepto: "",
            unidad: 7,
            cantidad: null,
            precio: null
        }];

        const breakpoint = (br) => {
            return breakpoints[currentBreakpoint] >= breakpoints[br]
        }

        const positiveNumberValidator = (rule, value, callback) => {
            if (value > 0) {
                callback()
            }
            else {
                callback("Numero positivo necesario")
            }
        }
        const numberRangeValidator = (rule, value, callback) => {
            if (!("condition" in rule) || rule.condition) {
                if ("max" in rule && value > rule.max) {
                    callback(rule.msg_max)
                }
                else if ("min" in rule && value < rule.min) {
                    callback(rule.msg_min)
                }
                else {
                    callback()
                }
            }
            else {
                callback()
            }
        }
        const documentNumberValidator = (rule, value, callback) => {

            switch (this.state.data.tipoDocumento) {
                case 96:
                    if (7 <= value.toString().length && value.toString().length <= 9) {
                        callback()
                    }
                    else {
                        callback("DNI incorrecto")
                    }
                    break;
                case 80:

                    if (typeof (value) === 'undefined'|| value === null || value === ''){
                        callback('CUIT requerido');
                    }

                    value = value.toString().replace(/[-_]/g, "");
                    if (value === ''){
                        callback('CUIT requerido')
                    }
                    else if (value.length !== 11){
                            callback('El cuit debe tener 11 numeros')
                    }
                    else {
                            var mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                            var total = 0;
                        for (var i = 0; i < mult.length; i++) {
                            total += parseInt(value[i]) * mult[i];
                            }
                        var mod = total % 11;
                        var digito = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;
                          }
                          if (digito === parseInt(value[10])){
                              this.setState({checkCuit:true})
                            callback()
                          } else{
                              callback('CUIT invalido')
                          }

                    break;
                case 94:
                    callback()
                    break;

                case 99:
                    callback()
                    break;
                default:
                    callback()
                    break;

            }
        }

        const displayAsociado = this.props.form.getFieldValue("comprobante") == "12" || this.props.form.getFieldValue("comprobante") == "13"
        
        const steps = [
            {
                title: 'Datos',
                content:
                    <>
                        <Row gutter={10}>
                            <Col lg={8}>
                                <Form.Item label="Tipo de comprobante">
                                    {
                                        getFieldDecorator('comprobante', {
                                            initialValue:11,
                                            value:this.state.data.tipoComprobante,
                                            rules: [{
                                                required: true,
                                            }],
                                        })(
                                            <Select
                                                onChange={(value) => {
                                                    resetFields(['comprobante-asociado'])
                                                    if (value === 12 || value === 13) {
                                                        this.updateData(["tipoComprobanteAsoc", "tipoComprobante"], [11, value])
                                                    } else { 
                                                        this.updateData(["tipoComprobanteAsoc", "tipoComprobante"], ["", value])
                                                    }
                                                }}
                                            >
                                                {
                                                    definitions.comprobante.map(value => {
                                                        return <Option key={value.value} value={value.value}>{value.name}</Option>
                                                    })
                                                }
                                            </Select>
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={8}>
                            <Form.Item label="Condición IVA Cliente">
                                    {
                                        getFieldDecorator('responsable', {
                                            rules: [{
                                                required: true,
                                            }],
                                            value: this.state.data.tipoResponsable,
                                            initialValue:"iva-responsable-inscripto",
                                        })(
                                            <Select
                                                onChange={(value) => {
                                                    resetFields(['numero-documento-cliente','documento-cliente','razon-social-cliente','domicilio-comercial-cliente'])
                                                    if (value === "consumidor-final") {
                                                        this.updateData(["tipoDocumento", "tipoResponsable"], [96, "consumidor-final"])
                                                    } else{
                                                        this.updateData(["tipoDocumento","tipoResponsable"],[80,value])
                                                        this.props.form.setFieldsValue({
                                                            'documento-cliente':'CUIT'
                                                        })
                                                    }
                                                }}
                                            >
                                                {
                                                    definitions.responsable.map(value => {
                                                        return (<Option key={value.value} value={value.value}>{value.name}</Option>)
                                                    })
                                                }
                                            </Select>
                                        )
                                    }
                                </Form.Item>

                            </Col>
                            <Col lg={8}>
                                <Form.Item label="Fecha comprobante">
                                    {
                                        getFieldDecorator('fecha-comprobante', {
                                            rules: [{
                                                required: true,
                                                message: 'Fecha de comprobante requerida',
                                            }],
                                            value:this.state.data.fecha,
                                            initialValue:moment()
                                        })(<DatePicker
                                            format="DD-MM-YYYY"
                                            locale={locale}
                                            style={{ width: '100%' }}
                                            defaultPickerValue={moment()}
                                            disabledDate={this.disableDate}
                                            onChange={(date) => this.updateData(["fecha"],[date])}
                                            allowClear={false}
                                            disabled={false}
                                        />)
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={10}>
                        <Col lg={8}>
                                <Form.Item label="Documento cliente">
                                    {
                                        getFieldDecorator('documento-cliente', {
                                            rules: [{
                                                required: true
                                            },],
                                            value: this.state.data.tipoDocumento,
                                            initialValue: this.state.data.tipoResponsable  === "consumidor-final"? 96:'CUIT'
                                        })(
                                            <Select
                                                onChange={(value) => {
                                                    this.updateData(["tipoDocumento","razonSocial","domicilioComercial","numeroDocumento"], [value,null, null, null])
                                                    resetFields(['numero-documento-cliente','domicilio-comercial-cliente','razon-social-cliente'])
                                                }}
                                                disabled={this.state.data.tipoResponsable !== "consumidor-final"}
                                            >
                                                {
                                                    documentos_cf.map(value => {
                                                        return (<Option key={value.value} value={value.value}>{value.name}</Option>)
                                                    })
                                                }
                                            </Select>
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={8}>
                            <Form.Item label={definitions.documento.filter(value => value.value === this.state.data.tipoDocumento)[0].name + " cliente"}>
                                    {
                                        getFieldDecorator('numero-documento-cliente', {
                                            rules: [
                                                {
                                                    required: this.state.data.tipoDocumento === 99 ? false : true,
                                                    message: 'Dato requerido'
                                                },
                                                {
                                                    validator: documentNumberValidator
                                                }
                                            ],
                                            value: this.state.data.numeroDocumento,
                                            initialValue:this.state.data.numeroDocumento,
                                            validateFirst: true
                                        })(
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                onChange={(value) => this.updateData(["numeroDocumento"], [value ? value : null])}
                                                disabled={this.state.data.tipoDocumento === 99}
                                                onBlur={()=>{
                                                   if(this.state.checkCuit === true){
                                                    this.cuitData()
                                                   } }}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>

                            <Col lg={8}>
                            <Form.Item label= {this.state.data.tipoDocumento !== 80 ? 'Nombre Cliente' : 'Razón social cliente'}>
                                    {
                                        getFieldDecorator('razon-social-cliente', {
                                            rules: [{
                                                required: this.state.data.tipoDocumento === 99 ? false : true,
                                                message: 'Razón Social requerida'
                                            }],
                                            value: this.state.data.razonSocial
                                        })(
                                            <Input
                                                disabled={this.state.data.tipoDocumento === 80 || this.state.data.tipoDocumento === 99 }
                                                onChange={(e) => this.updateData(["razonSocial"], [e.target.value ? e.target.value : null])}
                                            />
                                        )
                                    }
                                </Form.Item>

                            </Col>
                        </Row>
                        <Row gutter={10}>
                            <Col lg={8}>
                                <Form.Item label="Domicilio comercial cliente">
                                    {
                                        getFieldDecorator('domicilio-comercial-cliente', {
                                            value: this.state.data.domicilioComercial,
                                            rules: [
                                                {
                                                    required: this.state.data.tipoDocumento === 99 ? false : true,
                                                    message: "Domicilio requerido"
                                                }
                                            ]
                                        })(
                                            <Input
                                                disabled={this.state.data.tipoDocumento === 80 || this.state.data.tipoDocumento === 99}
                                                onChange={(e) => this.updateData(["domicilioComercial"], [e.target.value ? e.target.value : null])}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={8}>
                                <Form.Item label="Email Cliente">
                                    {
                                        getFieldDecorator('email-cliente', {
                                            value: this.state.data.email
                                        })(
                                            <Input
                                                onChange={(e) => this.updateData(["email"], [e.target.value ? e.target.value : null])}
                                                suffix={
                                                    <Tooltip title="La factura se enviará automáticamente a esta dirección.">
                                                        <Icon type="info-circle" />
                                                    </Tooltip>
                                                }
                                            />)
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={8}>
                            <Form.Item label="Concepto Venta">
                                    {
                                        getFieldDecorator('concepto', {
                                            initialValue: this.state.data.concepto,
                                            value:this.state.data.concepto,
                                            rules: [{
                                                required: true
                                            }],
                                        })(
                                            <Select
                                                onChange={(value) => this.updateData(["concepto"], [value])}
                                            >
                                                {
                                                    definitions.concepto.map(value => {
                                                        return <Option key={value.value} value={value.value}>{value.name}</Option>
                                                    })
                                                }
                                            </Select>
                                        )
                                    }
                                </Form.Item>
 
                            </Col>

                        </Row>
                        <Row gutter={10}>
                            <Col lg={8}>
                                <Form.Item label="Forma de Pago">
                                    {
                                        getFieldDecorator('forma-de-pago', {
                                            value: this.state.data.formaPago,
                                            initialValue: "cuenta-corriente",
                                            rules: [{
                                                required: true
                                            }],
                                        })(
                                            <Select
                                                onChange={(value) => this.updateData(["formaPago"], [value])}
                                            >
                                                {
                                                    definitions.formapago.map(value => {
                                                        return (<Option key={value.value} value={value.value}>{value.name}</Option>)
                                                    })
                                                }
                                            </Select>
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={8}>
                                <Form.Item label="Moneda">
                                    {
                                        getFieldDecorator('moneda', {
                                            initialValue:"PES",
                                            value:this.state.data.moneda,
                                            rules: [{
                                                required: true
                                            }],
                                        })(
                                            <Select
                                                onChange={(value) => this.updateData(["moneda"], [value])}
                                            >
                                                {
                                                    definitions.moneda.map(value => {
                                                        return (<Option key={value.value} value={value.value}>{value.name}</Option>)
                                                    })
                                                }
                                            </Select>
                                        )
                                    }
                                </Form.Item>
                            </Col>
                            <Col lg={8}>
                            <Form.Item label="Vto. para el pago">
                                        {
                                            getFieldDecorator('fecha-vencimiento', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Fecha Vencimiento requerida'
                                                }],
                                                value: this.state.data.fechaVencimiento,
                                                initialValue:this.state.data.fechaVencimiento

                                            })(<DatePicker
                                                onChange={(date) => this.updateData(["fechaVencimiento"], [date])}
                                                format="DD-MM-YYYY"
                                                locale={locale}
                                                style={{ width: '100%' }}
                                                allowClear={false}
                                            />)
                                        }
                                    </Form.Item>
                            </Col>
                        </Row>
                        {
                            this.props.form.getFieldValue("concepto") !== "1" &&
                            <Row gutter={[20]}>
                                <Col lg={8}>
                                    <Form.Item label="Desde">
                                        {
                                            getFieldDecorator('fecha-desde', {
                                                rules: [{
                                                    type: 'object',
                                                    required: true,
                                                    message: 'Fecha desde requerida'
                                                }],
                                                initialValue: this.state.data.fechaDesde
                                            })(<DatePicker
                                                onChange={(date) => this.updateData(["fechaDesde"],[date])}
                                                format="DD-MM-YYYY"
                                                locale={locale}
                                                style={{ width: '100%' }}
                                                allowClear={false}
                                            />)
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Hasta">
                                        {
                                            getFieldDecorator('fecha-hasta', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Fecha hasta requerida'
                                                }],
                                                initialValue: this.state.data.fechaHasta
                                            })(<DatePicker
                                                onChange={(date) => this.updateData(["fechaHasta"], [date])}
                                                format="DD-MM-YYYY"
                                                locale={locale}
                                                style={{ width: '100%' }}
                                                allowClear={false}
                                            />)
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {
                            displayAsociado &&
                            <Row gutter={10}>
                                <Col lg={8}>
                                    <Form.Item label="Tipo de comprobante asociado">
                                        {
                                            getFieldDecorator('comprobante-asociado', {
                                                initialValue: this.state.data.tipoComprobanteAsoc,
                                                value: this.state.data.tipoComprobanteAsoc,
                                                rules: [
                                                    {
                                                        required: this.state.data.tipoComprobante == 12 || this.state.data.tipoComprobante == 13,
                                                        message: 'Dato requerido'
                                                    }
                                                ],
                                            })(
                                                <Select
                                                    onChange={(value) => this.updateData(["tipoComprobanteAsoc"], [value])}
                                                    disabled={this.state.data.tipoComprobante !== 12 && this.state.data.tipoComprobante !== 13}
                                                >
                                                    {
                                                    definitions.comprobante.map(value => {
                                                            return <Option key={value.value} value={value.value}>{value.name}</Option>
                                                        })
                                                    }
                                                </Select>
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Punto de Venta">
                                    {
                                            getFieldDecorator('punto-venta-asociado', {
                                                rules: [{
                                                    required: this.state.data.tipoComprobante === 12 || this.state.data.tipoComprobante === 13,
                                                    message: 'Dato requerido'
                                                }],
                                                value: this.state.data.puntoVentaAsoc,
                                                initialValue: this.state.data.puntoVentaAsoc
                                            })(
                                                <InputNumber
                                                    disabled={this.state.data.tipoComprobante !== 12 && this.state.data.tipoComprobante !== 13}
                                                    style={{ width: '100%' }}
                                                    onChange={(value) => this.updateData(["puntoVentaAsoc"], [value ? value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                                <Col lg={8}>
                                    <Form.Item label="Número de Comprobante">
                                        {
                                            getFieldDecorator('comprobante-nro-asociado', {
                                                rules: [
                                                    {
                                                        required: this.state.data.tipoComprobante === 12 || this.state.data.tipoComprobante === 13,
                                                        message: 'Dato requerido'
                                                    }
                                                ],
                                                value: this.state.data.cbteNroAsoc,
                                                initialValue: this.state.data.cbteNroAsoc
                                            })(
                                                <InputNumber
                                                    disabled={this.state.data.tipoComprobante !== 12 && this.state.data.tipoComprobante !== 13}
                                                    style={{ width: '100%' }}
                                                    onChange={(value) => this.updateData(["cbteNroAsoc"], [value ? value : null])}
                                                />
                                            )
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col>
                                <Form.Item label="Observaciones">
                                    <TextArea
                                        value={this.state.data.observaciones}
                                        onChange={(e) => this.updateData(["observaciones"], [e.target.value ? e.target.value : null])}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
            },
            {
                title: 'Detalle',
                content:
                    <>
                        {
                            breakpoint("lg") ?
                                <>
                                    <Row gutter={[5]}>
                                        <Col lg={2}>
                                            <Text strong>Código</Text>
                                        </Col>
                                        <Col lg={6}>
                                            <Text strong>Concepto</Text>
                                        </Col>
                                        <Col lg={4}>
                                            <Text strong>Unidad</Text>
                                        </Col>
                                        <Col lg={3}>
                                            <Text strong>Cantidad</Text>
                                        </Col>
                                        <Col lg={4}>
                                            <Text strong>Precio</Text>
                                        </Col>
                                        <Col lg={4}>
                                            <Text strong>Subtotal</Text>
                                        </Col>
                                    </Row>
                                    {
                                        this.state.items.map((value, index) => {
                                            return (
                                                <Row key={value.key} gutter={[5]}>
                                                    <Col lg={2}>
                                                        <Form.Item>
                                                            {
                                                                getFieldDecorator('item-codigo-' + value.key, {
                                                                    initialValue: value.codigo,
                                                                    rules: [{
                                                                        required: true,
                                                                        message: "Código requerido"
                                                                    }]
                                                                })(
                                                                    <Input
                                                                        onChange={(e) => this.modifyItem(value.key, "codigo", e.target.value)}
                                                                        suffix={
                                                                            <Tooltip title="Si utilizas un código para identificar tu producto, agregalo acá.">
                                                                                <Icon type="info-circle" />
                                                                            </Tooltip>
                                                                        }
                                                                    />
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Form.Item>
                                                            {
                                                                getFieldDecorator('item-concepto-' + value.key, {
                                                                    rules: [{
                                                                        required: true,
                                                                        message: 'Concepto requerido'
                                                                    }],
                                                                    initialValue: value.concepto
                                                                })(
                                                                    <Input
                                                                        onChange={(e) => this.modifyItem(value.key, "concepto", e.target.value)}
                                                                        suffix={
                                                                            <Tooltip title="Escribí un breve resumen de lo que estas facturando.">
                                                                                <Icon type="info-circle" />
                                                                            </Tooltip>
                                                                        }
                                                                    />
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Form.Item>
                                                            {
                                                                getFieldDecorator('item-unidad-' + value.key, {
                                                                    rules: [{
                                                                        required: true,
                                                                        message: 'Unidad requerida'
                                                                    }],
                                                                    initialValue: value.unidad
                                                                })(
                                                                    <Select
                                                                        onChange={(newValue) => this.modifyItem(value.key, "unidad", newValue)}
                                                                    >
                                                                        {
                                                                            definitions.unidades.map(value => {
                                                                                return <Option key={value.value} value={value.value}>{value.name}</Option>
                                                                            })
                                                                        }
                                                                    </Select>
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                    <Col lg={3}>
                                                        <Form.Item>
                                                            {
                                                                getFieldDecorator('item-cantidad-' + value.key, {
                                                                    rules: [
                                                                        {
                                                                            required: true,
                                                                            message: 'Cantidad requerida'
                                                                        },
                                                                        {
                                                                            validator: positiveNumberValidator
                                                                        }
                                                                    ],
                                                                    initialValue: value.cantidad,
                                                                })(
                                                                    <InputNumber
                                                                        style={{ width: '100%' }}
                                                                        onChange={(e) => {
                                                                            this.modifyItem(value.key, "cantidad", e)
                                                                            resetFields(["total"])
                                                                        }}
                                                                    />
                                                                )
                                                            }

                                                        </Form.Item>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Form.Item>
                                                            {
                                                                getFieldDecorator('item-precio-' + value.key, {
                                                                    rules: [
                                                                        {
                                                                            required: true,
                                                                            message: 'Precio requerido'
                                                                        },
                                                                        {
                                                                            validator: positiveNumberValidator
                                                                        }
                                                                    ],
                                                                    initialValue: value.precio
                                                                })(
                                                                    <InputNumber
                                                                        style={{ width: "100%" }}
                                                                        prefix={<Icon type="dollar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                                        onChange={(e) => {
                                                                            this.modifyItem(value.key, "precio", e)
                                                                            resetFields(["total"])
                                                                        }}
                                                                    />
                                                                )
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <Input
                                                            prefix={<Icon type="dollar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                            style={{ marginTop: "4px" }}
                                                            disabled={true}
                                                            value={getFieldValue('item-precio-' + value.key) * getFieldValue('item-cantidad-' + value.key)}
                                                        />
                                                    </Col>
                                                    {
                                                        index !== 0 &&
                                                        <Col lg={1}>

                                                            <Form.Item>
                                                                <Button
                                                                    onClick={() => { this.deleteItem(value.key) }}
                                                                    icon="delete" style={{ color: '#f75050' }}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    }
                                                </Row>
                                            )
                                        })
                                    }
                                </>
                                :
                                <Row gutter={[5]}>
                                    {
                                        this.state.items.map((value, index) => {
                                            return (
                                                <Col key={index}>
                                                    <Card
                                                        extra={
                                                            index !== 0 ?
                                                                <Button
                                                                    size="small"
                                                                    onClick={() => { this.deleteItem(value.key) }}
                                                                    icon="delete" style={{ color: '#f75050' }}
                                                                />
                                                                :
                                                                null
                                                        }
                                                        title={"Item " + (index + 1)}
                                                        style={{ marginBottom: "5px" }}
                                                    >
                                                        <Col>
                                                            <Form.Item label="Código">
                                                                {
                                                                    getFieldDecorator('item-codigo-' + value.key, {
                                                                        initialValue: value.codigo,
                                                                        rules: [{
                                                                            required: true,
                                                                            message: "Código requerido"
                                                                        }]
                                                                    })(
                                                                        <Input
                                                                            onChange={(e) => this.modifyItem(value.key, "codigo", e.target.value)}
                                                                        />
                                                                    )
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item label="Concepto">
                                                                {
                                                                    getFieldDecorator('item-concepto-' + value.key, {
                                                                        rules: [{
                                                                            required: true,
                                                                            message: 'Concepto requerido'
                                                                        }],
                                                                        initialValue: value.concepto
                                                                    })(
                                                                        <Input
                                                                            onChange={(e) => this.modifyItem(value.key, "concepto", e.target.value)}
                                                                        />
                                                                    )
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item label="Unidad">
                                                                {
                                                                    getFieldDecorator('item-unidad-' + value.key, {
                                                                        rules: [{
                                                                            required: true,
                                                                            message: 'Unidad requerida'
                                                                        }],
                                                                        initialValue: value.unidad
                                                                    })(
                                                                        <Select
                                                                            onChange={(newValue) => this.modifyItem(value.key, "unidad", newValue)}
                                                                        >
                                                                            {
                                                                                definitions.unidades.map(value => {
                                                                                    return <Option key={value.value} value={value.value}>{value.name}</Option>
                                                                                })
                                                                            }
                                                                        </Select>
                                                                    )
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item label="Cantidad">
                                                                {
                                                                    getFieldDecorator('item-cantidad-' + value.key, {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: 'Cantidad requerida'
                                                                            },
                                                                            {
                                                                                validator: positiveNumberValidator
                                                                            }
                                                                        ],
                                                                        initialValue: value.cantidad
                                                                    })(
                                                                        <InputNumber
                                                                            style={{ width: '100%' }}
                                                                            onChange={(e) => {
                                                                                this.modifyItem(value.key, "cantidad", e)
                                                                                resetFields(["total"])
                                                                            }}
                                                                        />
                                                                    )
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item label="Precio">
                                                                {
                                                                    getFieldDecorator('item-precio-' + value.key, {
                                                                        rules: [
                                                                            {
                                                                                required: true,
                                                                                message: 'Precio requerido'
                                                                            },
                                                                            {
                                                                                validator: positiveNumberValidator
                                                                            }
                                                                        ],
                                                                        initialValue: value.precio
                                                                    })(
                                                                        <InputNumber
                                                                            style={{ width: "100%" }}
                                                                            prefix={<Icon type="dollar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                                            onChange={(e) => {
                                                                                this.modifyItem(value.key, "precio", e)
                                                                                resetFields(["total"])
                                                                            }}
                                                                        />
                                                                    )
                                                                }
                                                            </Form.Item>
                                                        </Col>
                                                        <Col>
                                                            <Form.Item label="Subtotal">
                                                                <Input
                                                                    prefix={<Icon type="dollar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                                    style={{ marginTop: "4px" }}
                                                                    disabled={true}
                                                                    value={getFieldValue('item-precio-' + value.key) * getFieldValue('item-cantidad-' + value.key)}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    </Card>
                                                </Col>
                                            )
                                        })
                                    }
                                </Row>
                        }
                        <Row gutter={[5]}>
                            <Col span={4}>
                                <Form.Item label=" ">
                                    <Button icon="plus-circle" onClick={() => this.addItem(defaultitem)}>
                                        Agregar item
                                        </Button>
                                </Form.Item>
                            </Col>
                            <Col span={4} offset={15}>
                                <Form.Item label="Total">
                                    {
                                        getFieldDecorator('total', {
                                            rules: [
                                                {
                                                    validator: numberRangeValidator,
                                                    max: this.state.maxInvoiceAmount,
                                                    msg_max: "Limite superado. Debes informar el DNI",
                                                    condition: this.state.data.tipoResponsable === "consumidor-final"
                                                }
                                            ],
                                            initialValue: this.getTotal()
                                        })(
                                            <Input
                                                type="primary"
                                                prefix={<Icon type="dollar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                style={{ marginTop: "4px" }}
                                                disabled={true}
                                            />
                                        )
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                    </>
            },
            {
                title: 'Resumen',
                content: <>
                <InvoiceView hideButtons = {true} invoice_id={this.state.invoiceID} />
                </>
            }
        ];

        return (
            <Base
                title="Facturar"
                selected="facturar"
            >
                <Card
                    title={
                        <Steps current={currentStep}>
                            {steps.map(item => (
                                <Step key={item.title} title={item.title} />
                            ))}
                        </Steps>
                    }
                    style={{ marginBottom: 10}}
                >
                    <Form hideRequiredMark >
                        <div className="steps-content">{steps[currentStep].content}</div>
                    </Form>
                    <div className="steps-action">
                        <Button.Group>
                            {currentStep > 0 && (
                                <Button onClick={() => this.prev()} disabled={this.state.loading}>
                                    Anterior
                            </Button>
                            )}
                            {currentStep < steps.length - 1 && (
                                <Button type="primary" onClick={() => this.next()} loading={this.state.loading}>
                                    Siguiente
                            </Button>
                            )}
                            {currentStep === steps.length - 1 && (
                                <Button type="primary" onClick={() => this.submitFactura()} loading={this.state.loading}
                                >
                                    Generar Comprobante
                            </Button>
                            )}
                        </Button.Group>
                    </div>
                </Card>
            </Base>
        );
    }}
}

const Invoice = Form.create({ name: 'invoice' })(withBreakpoints(InvoiceForm));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Invoice));
